module.exports = __webpack_public_path__ + "static/media/dogTime.d7639d34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ActivityBadge/icons/dogTime.svg
// module id = 294
// module chunks = 0